import React, { PropTypes } from 'react';
import cx from 'classnames';
import Modal from 'modules/common/components/Modal';
import Field from './Field';
import Big from 'big.js';
import $ from 'jquery';

export default class AccountingCodeModal extends React.Component {
  static propTypes = {
    line: PropTypes.object.isRequired,
    newLine: PropTypes.bool.isRequired,
    visible: PropTypes.bool.isRequired,
    readOnly: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = this.parseLine(props);

    this.setFromModel = this.setFromModel.bind(this);
  }

  parseLine(props) {
    const wrap = value => {
      return {
        value: value,
        error: props.newLine,
      };
    };

    const form = {};
    Object.keys(props.line).forEach(k => {
      form[k] = wrap(props.line[k]);
    });

    if (form.accounting_code) {
      form.accounting_code.error = false;
    }
    if (!form.id) {
      form.id = 0;
    }

    return form;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.line !== this.props.line) {
      this.setState({
        ...this.parseLine(nextProps),
      });
    }
  }

  onChangeAccountingCode = value => {
    this.setState({
      accounting_code: {
        value: value.target.value,
        error: false,
      },
    });
  };

  save = evt => {
    const newState = {};
    Object.keys(this.state).forEach(k => {
      if (this.state[k] === 0) {
        newState[k] = 0;
      } else if (k === 'id') {
        newState[k] = this.state[k] || 0;
      } else {
        newState[k] = this.state[k].value;
      }
    });

    this.props.onSave(newState);
  };

  onBlur = (evt, error) => {
    const newProp = {};
    newProp[evt.target.name] = {
      value: evt.target.value,
      error,
    };
    const newState = Object.assign({}, this.state, newProp);

    this.setState(newState);
  };

  setFromModel(model) {
    let newState = this.state;
    Object.keys(model).forEach(k => {
      if (this.state[k]) {
        newState[k] = {
          value: model[k],
          error: false,
        };
      }
    });
    this.setState(newState);
  }

  render() {
    const { visible, readOnly, line, onClose } = this.props;
    const data = this.state;

    const hasError =
      Object.keys(data).filter(
        k =>
          k !== 'description' &&
          k !== 'accounting_code' &&
          data[k] &&
          data[k].error
      ).length > 0;

    const buttonClass = cx('ui approve primary button icon labeled', {
      disabled: readOnly || hasError,
    });

    const title = line ? 'Modification' : 'Création';

    return (
      <Modal isOpened={visible} onClose={onClose} closable>
        <div className="header" style={{ position: 'relative', zIndex: 1 }}>
          <div className="ui grid" style={{ overflow: 'initial' }}>
            <div className="row">
              <div className="two wide column middle aligned">{title}</div>
            </div>
          </div>
        </div>
        <div className="content ui form">
          <form>
            <div className="one fields">
              <Field
                label="Code comptable"
                name="accounting_code"
                value={data.accounting_code}
                onChange={this.onChangeAccountingCode}
                onBlur={this.onBlur}
                required={true}
                readOnly={readOnly}
              />
            </div>
          </form>
        </div>
        <div className="actions">
          <button className={buttonClass} onClick={this.save}>
            <i className="icon add" />Editer
          </button>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/customers/components/AccountingCodeModal.js